import classnames from 'classnames'
import * as React from 'react'

import { SubMenu } from '../../../components/SubMenu/SubMenu'
import { Navigation } from './Navigation'

export interface Props {
  isContainer?: boolean
  rightContent?: React.ReactNode
  middleContent?: React.ReactNode
}

export default function Layout({
  children,
  isContainer = true,
  middleContent,
  rightContent,
}: React.PropsWithChildren<Props>) {
  // Remove min-height from react root element which is set on BE because of CLS
  React.useEffect(() => {
    document.getElementById('root')?.style.removeProperty('min-height')
  }, [])

  return (
    // Screen loader has min-h-64 (Website/js/main/components/loading.tsx)
    <div className="min-h-64">
      <SubMenu leftContent={<Navigation />} middleContent={middleContent} rightContent={rightContent} />
      <div
        className={classnames('is-js-module space-y-4 py-4', { 'fv-container has-responsive-padding': isContainer })}
      >
        {children}
      </div>
    </div>
  )
}
